<template>
  <div id="app">
    <div v-if="isSuper" class="superMode bar">
      <div class="mode-text">SUPER MODE</div>
    </div>
    <div v-if="isSuper" class="superMode console">
      <ul>
        <li>ENV: {{ ENV }}</li>
        <li>canonicalUrl: {{ canonicalUrl }}</li>
        <li><pre>Commit: {{ gitSHA }}</pre></li>
      </ul>
    </div>
    <AppDownload v-if="isMobile && !this['user/isMobileMenuOpen'] && $route.name !== 'HotelsMap' && $route.name !== 'OnlineTravel'" />
    <trackingBar v-if="showLinePointOrShopback === 'linepoints'" />
    <trackingBarShopback v-if="showLinePointOrShopback === 'shopback'" />
    <component :is="layout">
      <router-view />
    </component>
    <owlCookie v-if="$route.meta.cookie !== false" :lang="this['user/selectedLang']" class="z-50"></owlCookie>
    <!-- [2022-01-26] sidebar 已棄用 -->
    <!-- <sidebar></sidebar> -->
    <mobileMenu></mobileMenu>
    <searchMobileModal v-if="showSearchMobileModal"></searchMobileModal>

    <fixedBanner v-if="ctaList.length > 0 && $route.name !== 'OnlineTravel'" :list="ctaList"></fixedBanner>
    <promoteBanner></promoteBanner>
    <socialMedia v-if="$route.name !== 'OnlineTravel'"></socialMedia>

    <modals-container :key="$route.fullPath"/>
    <v-dialog :clickToClose="false" />
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import layoutDefault from '@/layouts/layoutDefault'
import layoutFrameless from '@/layouts/layoutFrameless.vue'
// import fixedBanner from '@/components/fixedBanner'
// import promoteBanner from '@/components/promoteBanner'
// import AppDownload from '@/components/appDownload'
import trackingBar from '@/components/trackingBar'
import trackingBarShopback from '@/components/trackingBarShopback'
import socialMedia from '@/components/socialMedia'
import ls from '@/utils/ls'

export default {
  name: 'App',
  metaInfo () {
    return {
      titleTemplate: (titleChunk) => {
        return titleChunk ? `${titleChunk} | ${this.$t('metaInfo.slogan')}` : this.$t('metaInfo.slogan')
      },
      htmlAttrs: {
        lang: this.langInHtml(this['user/selectedLang'])
      },
      link: [
        {
          rel: 'canonical', href: this.canonicalUrl
        },
        ...this.handleHrefLang()
      ],
      meta: [
        {
          'name': 'description',
          'content': '台灣各地民宿、旅館、villa都能訂，玩翻台灣超easy，全球最優惠的訂房網站，集滿5晚，第6晚半價，集滿8晚，第9晚免費，讓你住越多省越多，怎麼玩都不怕',
          'vmid': 'description'
        },
        {
          'property': 'og:url',
          'content': `${window.location.href}`,
          'vmid': 'og:url'
        },
        {
          'property': 'og:title',
          'template': chunk => chunk ? `${chunk} | 奧丁丁揪你訂房 - 揪你一起出去玩，旅館X民宿XVillaX青年旅館，想住哪就住哪 - OwlJourney` : `奧丁丁揪你訂房 - 揪你一起出去玩，旅館X民宿XVillaX青年旅館，想住哪就住哪 - OwlJourney`,
          'vmid': 'og:title'
        },
        {
          'property': 'og:description',
          'template': chunk => chunk ? `${chunk} | 台灣各地民宿、旅館、villa都能訂，玩翻台灣超easy，全球最優惠的訂房網站，讓你住越多省越大 ` : '台灣各地民宿、旅館、villa都能訂，玩翻台灣超easy，全球最優惠的訂房網站，讓你住越多省越大',
          'vmid': 'og:description'
        },
        {
          'property': 'og:image',
          'content': 'https://static.owljourney.com/images/production/ogimage.jpg?width=1200&height=630',
          'vmid': 'og:image'
        },
        {
          'property': 'og:image:width',
          'content': '1200',
          'vmid': 'og:image:width'
        },
        {
          'property': 'og:image:height',
          'content': '630',
          'vmid': 'og:image:height'
        },
        {
          'property': 'og:type',
          'content': 'website',
          'vmid': 'og:type'
        },
        {
          'property': 'og:site_name',
          'template': '奧丁丁揪你訂房 | OwlJourney',
          'vmid': 'og:site_name'
        },
        {
          'property': 'fb:app_id',
          'content': '929116720797252',
          'vmid': 'fb:app_id'
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '奧丁丁揪你訂房 OwlJourney',
            url: 'https://journey.owlting.com/',
            logo: 'https://journey.owlting.com' + this.logoImg,
            description: '台灣各地民宿、旅館、villa都能訂，玩翻台灣超easy，全球最優惠的訂房網站，集滿5晚，第6晚半價，集滿8晚，第9晚免費，讓你住越多省越多，怎麼玩都不怕',
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '+886-2-7727-6566',
              contactType: 'customer service',
              contactOption: 'TollFree'
            },
            email: 'owljourney@owlting.com'
          }
        },
        {
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            url: 'https://journey.owlting.com/',
            potentialAction: [
              {
                '@type': 'SearchAction',
                target: 'https://journey.owlting.com/collects?search={search_term_string}',
                'query-input': 'required name=search_term_string'
              },
              {
                '@type': 'SearchAction',
                target: 'https://journey.owlting.com/collects/{search_term_string}',
                'query-input': 'required name=search_term_string'
              }
            ]
          }
        }
      ]
    }
  },
  components: {
    'promoteBanner': () => import('@/components/promoteBanner'),
    'fixedBanner': () => import('@/components/fixedBanner'),
    'AppDownload': () => import('@/components/appDownload'),
    trackingBar,
    trackingBarShopback,
    socialMedia
  },
  data () {
    return {
      ENV: process.env.NODE_ENV,
      ctaList: [],
      gitSHA: process.env.VUE_APP_GTI_VERSION,
      logoImg: require('@/assets/images/logos/logo-tw.svg'),
      resize: null,
      layout: layoutFrameless
    }
  },
  methods: {
    ...mapActions([
      'bodyLock',
      'home/fetchBannerList',
      'home/fetchCurrencyRate',
      'search/fetchOptions',
      'user/fetchProfile',
      'user/fetchPhoneCodes',
      'metadata/fetchMetadata'
    ]),
    ...mapMutations([
      'SET_WINDOW_WIDTH',
      'SET_WINDOW_HEIGHT',
      'SET_SUPER',
      'SET_CURRENCY_EXIST',
      'SET_CURRENCY_SELECTABLE',
      'SET_SCROLL_TOP',
      'order/SET_TRACK_LINE_POINTS',
      'order/SET_TRACK_SHOPBACK',
      'order/CLEAR_CARTS',
      'order/CLEAR_ADDON_CARTS'
    ]),
    fetchCurrencyRate: function () {
      this['home/fetchCurrencyRate']().then(res => {
        if (res && res.length) {
          this['SET_CURRENCY_EXIST'](res)
          this['SET_CURRENCY_SELECTABLE'](res)
        }
      })
    },
    fetchBannerList: function () {
      this['home/fetchBannerList']().then(data => {
        this.ctaList = data
      })
    },
    /**
     * 記錄 line travel token
     */
    setCPS: function () {
      ls.set('owljourney_cps', { data: this.$route.query.owjtag, expiry: new Date().getTime() + 86400000 }) // 24 hours
      this.$router.replace({ query: { ...this.$route.query, owjtag: undefined } })
    },
    trackCPS: function () {
      const marketingTracking = ls.get('owljourney_cps')

      if (marketingTracking) {
        const isTrackCodeAlive = new Date().getTime() < marketingTracking.expiry

        if (!isTrackCodeAlive) {
          ls.remove('owljourney_cps')
        } else {
          this['order/SET_TRACK_LINE_POINTS'](marketingTracking.expiry)
        }
      } else {
        this['order/SET_TRACK_LINE_POINTS'](false)
      }
    },
    /**
     * 紀錄 shopback
     */
    setShopback: function () {
      ls.set('owljourney_shopback', { data: this.$route.query.sbid, expiry: new Date().getTime() + 86400000 }) // 24小時
      this.$router.replace({ query: { ...this.$route.query, utm_source : undefined, sbid: undefined, owltag: undefined } })
    },
    trackShopback: function () {
      const marketingTracking = ls.get('owljourney_shopback')

      if (marketingTracking) {
        const isTrackCodeAlive = new Date().getTime() < marketingTracking.expiry

        if (!isTrackCodeAlive) {
          ls.remove('owljourney_shopback')
        } else {
          this['order/SET_TRACK_SHOPBACK'](marketingTracking.expiry)
        }
      } else {
        this['order/SET_TRACK_SHOPBACK'](false)
      }
    },
    updateLayout: function () {
      if (this.$route.name) {
        if (!this.$route.meta.layout) {
            this.layout = layoutDefault
        } else {
          this.layout = this.$route.meta.layout
        }
      } else {
        this.layout = layoutFrameless
      }
      // if (!this.$route.meta.layout) {
      //   this.layout = layoutDefault
      // } else {
      //   this.layout = this.$route.meta.layout
      // }
    },
    handleScroll: function () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      this['SET_SCROLL_TOP'](scrollTop)
    },
    handleHrefLang: function () {
      const langs = ['zh-cn', 'ko', 'vi', 'tr', 'tl', 'nl', 'ms', 'it', 'id', 'hi', 'fr', 'es', 'de', 'cs', 'ar', 'ja', 'th']
      const array = []
      array.push({
        rel: 'alternate',
        href: this.canonicalUrl,
        hreflang: 'x-default'
      })
      for (let lang of langs) {
        array.push({
          rel: 'alternate',
          href: this.canonicalUrl + `?lang=${this.handleLang(lang)}`,
          hreflang: lang
        })
      }
      return array
    },
    handleLang: function (lang) {
      if (lang === 'zh-tw') {
        return 'zh_TW'
      }
      if (lang === 'zh-cn') {
        return 'zh_CN'
      }
      return lang
    },
    langInHtml: function (lang) {
      if (lang === 'zh_TW') {
        return 'zh-Hant'
      }
      if (lang === 'zh_CN') {
        return 'zh-Hants'
      }
      return lang
    }
  },
  computed: {
    ...mapGetters([
      'user/profile',
      'isSuper',
      'user/selectedLang',
      'order/dateRange',
      'search/dateRange',
      'isMobile',
      'isTablet',
      'order/trackingLinePoints',
      'order/trackingShopback',
      'user/isMobileMenuOpen',
      'user/isMobileSearchBarOpen'
    ]),
    canonicalUrl: function () {
      const reg = /\/$/gi
      let baseUrl = process.env.BASE_URL
      baseUrl = baseUrl.replace(reg, '')
      return location.protocol + '//' + location.host + baseUrl + this.$route.path
    },
    showSearchMobileModal: function () {
      if (!this.isMobile && !this.isTablet) {
        this.bodyLock(false)
      }
      return this.isMobile || this.isTablet
    },
    showLinePointOrShopback: function () {
      if (this['order/trackingLinePoints'] && !this['order/trackingShopback']) {
        return 'linepoints'
      } else if (!this['order/trackingLinePoints'] && this['order/trackingShopback']) {
        return 'shopback'
      } else if (this['order/trackingLinePoints'] && this['order/trackingShopback']) {
        const shopback = ls.get('owljourney_shopback')
        const linepoints = ls.get('owljourney_cps')
        if (shopback.expiry >= linepoints.expiry) {
          return 'shopback'
        } else {
          return 'linepoints'
        }
      } else {
        return false
      }
    }
  },
  watch: {
    '$route': {
      handler: function (newVal, oldVal) {
        if (this.$route.query.owjtag) {
          this.setCPS()
        }
        if (this.$route.query.sbid) {
          this.setShopback()
        }
        this.trackCPS()
        this.trackShopback()
        if (newVal !== oldVal) {
          const allPopups = ['fullPageModal', 'dialog']

          for (const dialog of allPopups) {
            this.$modal.hide(dialog)
          }
          this.updateLayout()
        }
      },
      immediate: true
    }
  },
  created () {
    this.updateLayout()
    this.fetchCurrencyRate()
    this.fetchBannerList()
    // VueFacebookPixel
    if (window.fbq && process.env.NODE_ENV === 'production') {
      window.fbq('init', '2487666051557981')
      window.fbq('track', 'PageView')
    }
    // check if user logged in
    this['user/fetchProfile']()
    // get phone codes
    this['user/fetchPhoneCodes']()

    this['metadata/fetchMetadata']()

    this.resize = _.debounce(() => {
      if (window.innerWidth) {
        this['SET_WINDOW_WIDTH'](window.innerWidth)
      }
      if (window.innerHeight) {
        this['SET_WINDOW_HEIGHT'](window.innerHeight)
      }
    }, 300)

    const that = this
    Object.defineProperty(window, 'supermode', {
      get: function () {
        that.SET_SUPER(!that.isSuper)
        const msg =
        /* eslint-disable */
        `
           _____ _____ _____ _____ _____    _____ _____ ____  _____
          |   __|  |  |  _  |   __| __  |  |     |     |    \|   __|
          |__   |  |  |   __|   __|    -|  | | | |  |  |  |  |   __|
          |_____|_____|__|  |_____|__|__|  |_|_|_|_____|____/|_____|
        `
        /* eslint-enable */
        if (that.isSuper) {
          console.log(`%c${msg}`, 'color: red;')
          return `#Nasty #Yay 🎉`
        }
        if (!that.isSuper) {
          console.log(`%c${msg}`, 'color: grey;')
          return `#Sorry for your loss. 🤪`
        }
      },
      configurable: true
    })
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.resize)
    if (window.innerWidth) {
      this['SET_WINDOW_WIDTH'](window.innerWidth)
    }
    if (window.innerHeight) {
      this['SET_WINDOW_HEIGHT'](window.innerHeight)
    }

    // clear localstorage cart if date expired
    const isCartDateExpired = this.$dayjs(this.$dayjs(this['order/dateRange'].start).isBefore(this.$dayjs()), 'day')
    // const isSearchDateExpired = this.$dayjs(this.$dayjs(this['search/dateRange'].start).isBefore(this.$dayjs()), 'day')
    if (isCartDateExpired) {
      console.debug('CART EXPIRED -> CLEAR_CARTS')
      this['order/CLEAR_CARTS']()
      this['order/CLEAR_ADDON_CARTS']()
    }
  },
  updated () {
    this.resize()
    this.updateLayout()
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resize)
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="sass">
#app
  @apply antialiased
  // @apply subpixel-antialiased
  @apply text-grey-darkest
  // font-family: "微軟正黑體"

.superMode
  .mode-text
    @apply fixed
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    // filter: blur(3px)
    font-size: 10rem
    @apply text-center font-bold
    color: white
    opacity: .1
    text-shadow: 4px 5px 2px black
  &.bar
    @apply fixed select-none pointer-events-none z-999
    top: 0
    left: 0
    width: 100%
    height: 100vh
    background:
      color: rgba(red, .1)
      image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABZJREFUeNpi2r9//38gYGAEESAAEGAAasgJOgzOKCoAAAAASUVORK5CYII=)
    // background: -webkit-linear-gradient(to right, #DC281E, #F00000)
    // background: linear-gradient(to right, #DC281E, #F00000)
    // opacity: .1
    // backdrop-filter: grayscale(.5)
    // border:
    //   width: 4px
    //   color: #F00000
  &.console
    @apply fixed px-8 py-16 w-full text-red font-mono
    background: rgba(#4F3A3A, .9)
    bottom: 0
    left: 0
    z-index: 999

$loading-bg: config('colors.grey-lightest')
$loading-flash: config('colors.grey-lighter')
*[lazy=loading]
  @apply bg-grey-lightest
  max-height: 230px

$tippy-bg: config('colors.grey-darker')
.tippy
  @apply cursor-pointer outline-none ease
  &-active, &:focus
    @apply outline-none
    &:focus, &:hover
      @apply outline-none
  &-tooltip
    background-color: $tippy-bg
    @apply p-16 text-base
.tippy-popper[x-placement^='top'] .tippy-tooltip .tippy-arrow
  border-top-color: $tippy-bg
.tippy-popper[x-placement^='bottom'] .tippy-tooltip .tippy-arrow
  border-bottom-color: $tippy-bg
.tippy-popper[x-placement^='left'] .tippy-tooltip .tippy-arrow
  border-left-color: $tippy-bg
.tippy-popper[x-placement^='right'] .tippy-tooltip .tippy-arrow
  border-right-color: $tippy-bg

.fixed-loading
  overflow: hidden
  // .el-loading-mask
    // @apply rounded-sm
  .el-loading-spinner
    @apply m-0 #{!important}
    transform: translate(0, -50%) !important

button, .btn, .agile__nav-button
  touch-action: manipulation

.body-lock
  overflow: hidden
  height: 100%
.displayResult
  // @apply cursor-default #{!important}
  &:focus
    background-color: transparent !important
    color: #889096 !important

</style>
